export function dateString(v) {
  // give value in milliseconds, turn it to date string
  if (typeof(v)==='number') {
    const d = new Date(v)
    return d.toLocaleString()
  }
  // direct display if already in string
  if (typeof(v)==='string') {
    return v
  }
  return ''
}

export function readFile(p, cb) {
  if (typeof(p)==='string'&&p.length>0) {
    const filePath = '../data/'+p
    fetch(filePath).then(response=>{
      if(response.ok) {
        return response.text()
      }
      throw new Error('Network response was not ok.')
    }).then(data=>{
      if (typeof(cb)==='function') {
        cb(data)
      }
    })
  }
}

export function readJson(p, cb) {
  if (typeof(p)==='string'&&p.length>0) {
    const filePath = '../data/' + p
    fetch(filePath).then(response=>{
      if(response.ok) {
        return response.json()
      }
      throw new Error('Network response was not ok.')
    }).then(data=>{
      if (typeof(cb)==='function') {
        cb(data)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/Utils.js